const escapeHtml = (value: string) =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('\"', '&quot;')
    .replaceAll("'", '&#39;')

export const formatSmartTextHtml = (
  text: string | null | undefined,
  noWrapPhrases: string[] = [],
  className = 'automotive-product__nowrap'
) => {
  const source = text || ''
  let html = escapeHtml(source)

  // Keep the previous visible character and trailing punctuation on the same line.
  // This handles both full-width and ASCII punctuation, even if the source text has stray spaces before it.
  html = html.replace(
    /([^\s>])(\s*[\uFF1B\uFF1A\uFF0C\u3002\uFF01\uFF1F,.;:!?])/gu,
    `<span class="${className}">$1$2</span>`
  )

  // Keep numeric values and their following unit/direction text together, such as:
  // 360°水平, 24 小时, 20°, 80 %, 7×24h
  html = html.replace(
    /(\d+(?:\.\d+)?(?:\s?(?:[\u00B0%\u2103\u2109A-Za-z]+|[\u4E00-\u9FFF]+))+)/gu,
    `<span class="${className}">$1</span>`
  )

  noWrapPhrases
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)
    .forEach((phrase) => {
      const escapedPhrase = escapeHtml(phrase)
      html = html.replaceAll(escapedPhrase, `<span class="${className}">${escapedPhrase}</span>`)
    })

  return html
}
